export const statuses = {
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
  PAID: 'PAID',
  FINISHED: 'FINISHED',
  CANCELLED: 'CANCELLED',
  PAID_OUT: 'PAID_OUT',
};
export const KLARNA_MAX_AMOUNT_ORE = 3_000_000;
